import * as ng from 'angular';
import { Moment } from 'moment';

let TimespanFormatDirective: ng.Injectable<ng.IDirectiveFactory> =
    function (moment: Moment) {
        return {
            require: 'ngModel',
            restrict: "A",
            link: (scope: ng.IScope,
                element: ng.IAugmentedJQueryStatic,
                attrs: ng.IAttributes,
                ngModel: ng.INgModelController) => {

                // convert utc date to local for display  
                ngModel.$formatters.push((inboundTimespan) => {
                    var localMoment = moment as any;
                    try {

                        return (inboundTimespan)
                            ? localMoment(localMoment().format("YYYY-MM-DD"))
                                .add(localMoment.duration(inboundTimespan))
                                .toDate()
                            : inboundTimespan;
                    }
                    catch (e) {
                        return null; 
                    }
                });

                // convert local date to utc for storage
                ngModel.$parsers.push((outboundDatetime) => {
                    try {
                        var localMoment = moment as any;
                        return (outboundDatetime)
                            ? localMoment.duration(localMoment(outboundDatetime).format("HH:mm")).toIsoString()
                            : outboundDatetime;
                    }
                    catch (e) {
                        return null;
                    }
                });
            }
        }
    };


TimespanFormatDirective.$inject = ['moment'];

export let TimespanFormat = {
    name: 'tsFormat',
    factory: TimespanFormatDirective
};

//(function () {
//    'use strict';

//    angular
//        .module('app')
//        .directive('datepicker', Directive);

//    function Directive($filter) {
//        return {
//            require: 'ngModel',
//            link: function (scope, element, attr, ngModel) {
//                element.addClass('datepicker');
//                element.pickadate({ format: 'dd/mm/yyyy', editable: true });

//                // convert utc date to local for display
//                ngModel.$formatters.push(function (utcDate) {
//                    if (!utcDate)
//                        return;

//                    return $filter('utcToLocal')(utcDate, 'dd/MM/yyyy');
//                });

//                // convert local date to utc for storage
//                ngModel.$parsers.push(function (localDate) {
//                    if (!localDate)
//                        return;

//                    return moment(localDate, 'DD/MM/YYYY').utc().toISOString();
//                });
//            }
//        };
//    }
//})();


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/setup/timespan-formatter.ts